<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <AromaAlphabetCheckout :combos="combos" :variant="variant" />
  </b-container>
</template>
<style>

</style>

<script>
import AromaAlphabetCheckout from "@/components/checkout/aromaalphabet/AromaAlphabetCheckout.vue";

export default {
  title: 'Aroma Alphabet Checkout',
  name: "AromaAlphabet",
  props: ["combos"],
  components: {
    AromaAlphabetCheckout
  },
  computed: {
    variant: function () {
      var q = this.$route.query;
      var variant = null;
      if (q && "v" in q && ["A", "B", "C"].includes(q["v"])) {
        variant = q["v"];
        q = Object.assign({}, this.$route.query);
        delete q.v;
        this.$router.replace({ q });
        localStorage.setItem("variant", variant);
      } else {
        let storedVariant = localStorage.getItem("variant");
        variant = ["A", "B", "C"].includes(storedVariant) ? storedVariant : "A";
      }

      console.log("url: " + q + ", variant = " + variant);
      return variant;
    },
  },
};
</script>
